import React from 'react';
import { useParams } from 'react-router-dom';
import SurveyTokenForm from '../components/SurveyTokenForm';
import { PRE_EVENT_SURVEY_QUESTIONS } from '../lib/api/surveys';

const PreEventSurveyPage: React.FC = () => {
  const { token = '' } = useParams<{ token: string }>();

  return (
    <SurveyTokenForm
      token={token}
      expectedSurveyKey="pre_event"
      surveyTitle="Pre-Event Survey"
      questions={PRE_EVENT_SURVEY_QUESTIONS}
    />
  );
};

export default PreEventSurveyPage;
